import { createRequest, RequestConfig } from 'app/common/api';

const config: RequestConfig = {
  method: 'get',
  url: '/ws/api/get_employee_roles',
};

export const getEmployeeRolesRequest = () =>
  createRequest({
    url: config.url,
    method: config.method,
  });
